import { m } from "framer-motion"
import { varBounce } from "minimals-template/components/animate"

export const BounceAnimation = ({ children }) => <m.div variants={varBounce().in}>{children}</m.div>
